// Tenant resolution from the URL host.
// On <slug>.198x.ai the subdomain IS the workspace slug, so login can auto-lock the
// workspace and skip the "enter company" step. On the bare domain, app./admin./www.,
// leads.estaie.org, or localhost there's no tenant subdomain → normal workspace-first login.

const ROOT = '198x.ai';
const RESERVED = new Set(['www', 'app', 'api', 'admin', 'login', 'dashboard']);

export function tenantSlug(): string | null {
  const host = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  if (!host.endsWith(ROOT)) return null;
  const sub = host.slice(0, -ROOT.length).replace(/\.$/, ''); // "estaie.198x.ai" -> "estaie"
  if (!sub || sub.includes('.')) return null;                  // bare domain or multi-level
  return RESERVED.has(sub) ? null : sub;
}

// From the bare/app entry on 198x.ai, send the user to their workspace subdomain to sign in
// (sessions are per-origin, so login must happen on the subdomain). Returns null elsewhere
// (leads.estaie.org / localhost / already on the right subdomain) → log in in place.
export function tenantLoginUrl(slug: string): string | null {
  const host = (typeof window !== 'undefined' ? window.location.hostname : '').toLowerCase();
  if (host === ROOT || host === `app.${ROOT}`) return `https://${slug}.${ROOT}/login`;
  return null;
}
